export default () => {
  const listQuote = ref([] as string[])

  const searchQuoteByOrder = async (orderId: string) => {
    if (!orderId) {
      resetListQuote()
      return
    }

    const api: any = $urlPartner.order.order.searchQuote

    const res = await $api(api, { uriParams: { ID: orderId } })

    const resData: any = res?.data?.value
    if (resData?.success) {
      listQuote.value = resData.data || []
      return
    }

    resetListQuote()
  }

  const handleAddQuoteToOrder = async (orderId: string, data: { [key: string]: string }) => {
    if (!orderId) {
      return false
    }

    if (!data) {
      return false
    }

    const api: any = $urlPartner.order.order.addQuoteToOrder

    const res = await $api(api, { uriParams: { ID: orderId }, body: data })

    const resData: any = res?.data?.value
    if (resData?.success) {
      process.client && $toast().success(resData.data)

      return resData.meta?.order
    }
    return false
  }

  const handleEditQuoteToOrder = async (orderId: string, data: { [key: string]: string }) => {
    if (!orderId) {
      return
    }

    if (!data) {
      return
    }

    const api: any = $urlPartner.order.order.editQuoteToOrder

    const res = await $api(api, { uriParams: { ID: orderId }, body: data })

    const resData: any = res?.data?.value
    if (resData?.success) {
      process.client && $toast().success(resData.data)
      return resData.meta?.order
    }
    return false
  }

  const resetListQuote = () => {
    listQuote.value = []
  }

  return {
    listQuote,
    searchQuoteByOrder,
    handleAddQuoteToOrder,
    handleEditQuoteToOrder,
    resetListQuote
  }
}
